
import { Session, User as SupabaseUser } from '@supabase/supabase-js';
import { User } from './types';
import { toast } from '@/hooks/use-toast';

export const createUserFromSupabaseUser = (user: SupabaseUser): User => {
  const isAdmin = user.app_metadata?.is_admin === true ||
    user.app_metadata?.is_admin === 'true' ||
    false;
  const canReviewAssessments = isAdmin ||
    user.app_metadata?.assessment_reviewer === true ||
    user.app_metadata?.assessment_reviewer === 'true' ||
    false;

  return {
    id: user.id,
    email: user.email || undefined,
    isAdmin,
    canReviewAssessments,
    name: user.user_metadata?.name || user.user_metadata?.full_name || user.email || '',
    avatar_url: user.user_metadata?.avatar_url || undefined,
  };
};

export const handleSessionChange = (
  event: string,
  session: Session | null,
  setCurrentUser: (user: User | null) => void,
  setSessionExpireTime: (time: number | null) => void
) => {
  console.log("Auth state changed:", event);

  if (event === 'SIGNED_OUT') {
    console.log("User signed out");
    setCurrentUser(null);
    setSessionExpireTime(null);
    return;
  }

  if (session?.user && (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED')) {
    console.log("User signed in or token refreshed:", session.user.id);
    console.log("Session expires at:", new Date(session.expires_at * 1000).toLocaleString());

    setSessionExpireTime(session.expires_at);
    setCurrentUser(createUserFromSupabaseUser(session.user));
  }
};

export const handleSessionRefreshError = () => {
  toast({
    title: "Session refresh failed",
    description: "Please log out and log back in to continue.",
    variant: "destructive"
  });
};

export const handleLoginSuccess = (name?: string) => {
  toast({
    title: "Login Successful",
    description: `Welcome back${name ? ', ' + name : ''}!`
  });
};

export const handleLogoutSuccess = () => {
  toast({
    title: "Logged Out",
    description: "You have been successfully logged out."
  });
};
